import type { AuthHeaders } from './types';

const createAuthHeaders = (accessToken: string): AuthHeaders => ({
	Authorization: `Bearer ${accessToken}`
});

export { createAuthHeaders };
